export default "__VITE_ASSET__BB$IM_Ib__"